module.exports = (__parcel__import__("2YnsD")).then(() => parcelRequire('lmhgI'));